import { events } from '../../api/api'
import queryString from 'query-string'
import moment from 'moment'

import { setCategories, setLocations, setStartDate, setEndDate, setView } from './setFilters'
import setEventSchedule from './setEventSchedule'
import { getEventSchedule } from '../../utilities/content/eventSchedule'
import { fetchFilterContent } from './fetchFilterContent'
import { defaultView, enableViewFilter } from '../../configuration/configs'

export const FETCH_EVENTS_BEGIN = 'FETCH_EVENTS_BEGIN'
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS'
export const FETCH_EVENTS_ERROR = 'FETCH_EVENTS_ERROR'

export const fetchEvents = () => async (dispatch) => {
  const queryParams = queryString.parse(window.location.search)
  const { category, categories, locations, date, startDate, endDate, view } = queryParams

  if (category) {
    dispatch(setCategories(category))
  }

  if (categories) {
    /**
     * split the supplied categories into an array
     * since we don't know what the delimeter will be
     * use regex to check for either | or , as they are common
     * delimiters
     */
    let processedCategories = decodeURIComponent(categories)
    processedCategories = processedCategories.split(/\||,/)
    dispatch(setCategories(processedCategories))
  }

  if (locations) {
    /**
     * split the supplied categories into an array
     * since we don't know what the delimeter will be
     * use regex to check for either | or , as they are common
     * delimiters
     */
    let processedLocations = decodeURIComponent(locations)
    processedLocations = processedLocations.split(/\||,/)
    dispatch(setLocations(processedLocations))
  }

  if (date) {
    dispatch(setStartDate(moment(date)))
  }
  if (startDate) {
    dispatch(setStartDate(startDate))
  }
  if (startDate && endDate) {
    if (moment(startDate).isBefore(moment(endDate))) {
      dispatch(setEndDate(endDate))
    }
  }

  if (view) {
    dispatch(setView(view))
  } else {
    dispatch(setView(defaultView))
  }

  dispatch({ type: FETCH_EVENTS_BEGIN })

  return events()
    .then((res) => {
      if (res) {
        if (res && res.data) {
          dispatch({
            type: FETCH_EVENTS_SUCCESS,
            payload: res.data,
          })

          if (enableViewFilter) {
            dispatch(setEventSchedule(getEventSchedule(res?.data?.events)))
          }
          dispatch(fetchFilterContent(res?.data?.events))
        }
      } else {
        dispatch({
          type: FETCH_EVENTS_ERROR,
          payload: 'There was an error retrieving events - please wait a moment, then try again.',
        })
      }
    })
    .catch((err) => {
      dispatch({
        type: FETCH_EVENTS_ERROR,
        payload: 'There was an error retrieving events - please wait a moment, then try again.',
      })
    })
}
